import React from 'react'
import { makeStyles } from '@material-ui/styles'
import GrinMenuItem from 'components/common/menu/GrinMenuItem'
import { Grid } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'

const useStyles = makeStyles(theme => ({
  selectedOption: {
    backgroundColor: 'rgba(235, 235, 235, 1)'
  },
  iconContainer: {
    lineHeight: 0.8,
    width: 24
  }
}))

/**
 * @param {Object} props
 * @param {string} [props.id] - The ID of the menu item.
 * @param {Function} props.onClick
 * @param {import('components/common/buttons/GrinButton/GrinButton').GrinButtonOption} props.option
 */
const NoteVisibilityMenuItem = ({ id, onClick, option }) => {
  const classes = useStyles()

  return (
    <GrinMenuItem id={id} onClick={onClick} className={option.selected ? classes.selectedOption : ''}>
      <Grid container alignItems="center">
        <Grid item className={classes.iconContainer}>
          {option.icon}
        </Grid>
        <Grid item>
          <DazzedParagraph14 strong> {option.label}</DazzedParagraph14>
        </Grid>
      </Grid>
    </GrinMenuItem>
  )
}

export default NoteVisibilityMenuItem
